import React, { useState } from 'react';
import { jobs, Job } from '../data/jobs';

const Career: React.FC = () => {
  const [selectedJob, setSelectedJob] = useState<Job | null>(null);

  return (
    <section id="career" className="py-20 bg-surface-soft min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Banner/Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4 text-ink-900">
            Join Our Team – We’re Hiring!
          </h2>
          <p className="text-lg text-ink-500 max-w-2xl mx-auto">
            Explore exciting IT career opportunities and grow with us.
          </p>
        </div>

        {/* Job Listings */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {jobs.map((job) => (
            <div key={job.id} className="glass-card p-8 flex flex-col justify-between">
              <div>
                <h3 className="text-2xl font-semibold mb-2 text-ink-900">{job.title}</h3>
                <div className="flex flex-wrap gap-4 mb-4 text-sm text-ink-500">
                  <span className="inline-block bg-ink-100 rounded px-2 py-1">{job.location}</span>
                  <span className="inline-block bg-ink-100 rounded px-2 py-1">{job.employmentType}</span>
                </div>
                <p className="text-ink-500 mb-6">{job.shortDescription}</p>
              </div>
              <button
                className="mt-auto bg-brand-start hover:bg-brand-end text-white font-semibold py-2 px-4 rounded transition-colors duration-200"
                onClick={() => setSelectedJob(job)}
              >
                View Details
              </button>
            </div>
          ))}
        </div>

        {/* Modal for Job Details */}
        {selectedJob && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 transition-opacity duration-300">
            <div className="glass-card border border-white/20 shadow-2xl max-w-lg w-full p-8 relative animate-fade-in">
              <button
                className="absolute top-3 right-3 text-ink-400 hover:text-brand-start bg-white/70 hover:bg-brand-start/10 rounded-full w-9 h-9 flex items-center justify-center text-xl transition-colors duration-200 shadow"
                onClick={() => setSelectedJob(null)}
                aria-label="Close"
              >
                <span className="sr-only">Close</span>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-6 h-6">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
              <h3 className="text-2xl font-semibold mb-2 text-ink-900">{selectedJob.title}</h3>
              <div className="flex flex-wrap gap-4 mb-4 text-sm text-ink-500">
                <span className="inline-block bg-ink-100 rounded px-2 py-1">{selectedJob.location}</span>
                <span className="inline-block bg-ink-100 rounded px-2 py-1">{selectedJob.employmentType}</span>
              </div>
              <p className="text-ink-500 mb-4">{selectedJob.detailedDescription}</p>
              <button
                className="mt-4 bg-brand-start hover:bg-brand-end text-white font-semibold py-2 px-4 rounded transition-colors duration-200"
                onClick={() => setSelectedJob(null)}
              >
                Close
              </button>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};

export default Career;